import { useMemo, useState } from 'react'
import { useTable, ColumnInstance, Row } from 'react-table'
import { useQueryResponseLoading } from '../core/QueryResponseProvider'
import driverAreaColumns from './columns/_columns'
// import {Customer} from '../core/_models'
import DriverAreaLoading from '../components/loading/driverAreaLoading'
// import CustomersListPagination from '../components/pagination/CustomersListPagination'
import { KTCard, KTCardBody } from '../../../../../../_template/helpers'
import { useSelector } from 'react-redux'
import { CustomHeaderColumn } from './columns/CustomHeaderColumn'
import { CustomRow } from './columns/CustomRow'
import DriverAreaSearchComponent from '../components/header/driverAreaSearchComponent'
import { useAppDispatch } from '../../../../../hooks'
import { getAllFunction } from '../../../../../redux/actions/commonCrud'
import * as endpoints from '../../../../../../_template/helpers/endpoints'
import * as actionTypes from '../../../../../redux/actionTypes'
import TCustomerFilterValues from '../../../../../types/TCustomerFilterValues'
import PaginationComponent from '../../../../../../_template/layout/components/pagination'

const DriverAreaTable: React.FC = () => {
  const driverAreas = useSelector(({ config }: { config: ConfigState }) => config.driverAreas);
  const totalPages = useSelector(({ config }: { config: ConfigState }) => config.totalPages);

  // const driver_areas_fake_data = [{
  //   _id: 1,
  //   label: "طرابلس المركز",
  //   description: "",
  //   city: "طرابلس",
  //   createDate: new Date(),
  //   radius: 2814.17,
  //   latitude: 32.89678995422581,
  //   longitude: 13.196403980255129
  // }, {
  //   _id: 2,
  //   label: "جنزور",
  //   description: "",
  //   city: "طرابلس",
  //   createDate: new Date(),
  //   radius: 3235.615962396813,
  //   latitude: 32.87170682268786,
  //   longitude: 13.133575916290285
  // }, {
  //   _id: 3,
  //   label: "تاجورا",
  //   description: "",
  //   city: "طرابلس",
  //   createDate: new Date(),
  //   radius: 5503.783862825648,
  //   latitude: 32.89186612530056,
  //   longitude: 13.33371162414551
  // }];

  const [filterValues, setFilterValues] = useState<TCustomerFilterValues>()
  const handleChangeValues = (e?: React.ChangeEvent<any>) => {

    if (e) {
      setFilterValues({
        // ...filterValues,
        // ...filterObject,
        [e.target.name]: e.target.value,
      })
    } else {
      setFilterValues(undefined)
    }
  }

  const dispatch = useAppDispatch()
  const handleDispatch = () => { dispatch(getAllFunction(endpoints.DriverAreas, actionTypes.GET_ALL_DRIVER_AREAS, { ...filterValues })) }

  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => driverAreas, [driverAreas])
  const columns = useMemo(() => driverAreaColumns, [])
  const { getTableProps, getTableBodyProps, headers, rows, prepareRow } = useTable({
    columns,
    data,
  })

  return (
    <KTCard>
      <KTCardBody className='py-4'>
        <div className='d-flex justify-content-between'>
          <div className='w-100'>
            <DriverAreaSearchComponent
              filterValues={filterValues}
              handleChangeValues={handleChangeValues}
              handleDispatch={handleDispatch}
            // eventKey={eventKey}
            />
          </div>
          {/* <div style={{width: '180px'}}>
            <UsersListFilter eventKey={eventKey} />
          </div> */}
        </div>

        <div className='table-responsive'>
          <table
            id='kt_table_users'
            className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
            {...getTableProps()}
          >
            <thead>
              <tr className='text-muted fw-bolder fs-7 text-uppercase gs-0'>
                {headers.map((column: ColumnInstance<any>) => (
                  <CustomHeaderColumn key={column.id} column={column} />
                ))}
              </tr>
            </thead>
            <tbody className='text-gray-500 fs-6' {...getTableBodyProps()}>
              {rows.length > 0 ? (
                rows.map((row: Row<any>, i) => {
                  prepareRow(row)
                  return <CustomRow row={row} key={`row-${i}-${row.id}`} />
                })
              ) : (
                <tr>
                  <td colSpan={7}>
                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                      No matching records found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* <CustomersListPagination /> */}
        <PaginationComponent
          values={filterValues}
          setValues={setFilterValues}
          endpoint={endpoints.trackingStatus}
          actionType={actionTypes.GET_ALL_TRACKING_STATUS}
          totalPages={totalPages}
        />
        {isLoading && <DriverAreaLoading />}
      </KTCardBody>
    </KTCard>
  )
}

export default DriverAreaTable
